import React, {useEffect, useState} from "react";
import {EmptyState, Loader, MovieCard} from "../../components";
import {Box, List, ListItemButton, ListItemIcon, ListItemText, Stack, Typography} from "@mui/material";
import styles from "./MyEpic.module.css";
import CustomTabs from "../../components/Tabs/Tabs";
import {getDataMyList, IKey, useDataList} from "./data";
import Keys from "../../constants/helper";
import {useTranslation} from "react-i18next";
import useResize from "../../hooks/useResize";
import {NextIcon} from "../../assets/files";
import {useLazyGetListQuery} from "../../api/modules";
import {IProfileList} from "../../store/profile/types";
import {TABLET_VERSION} from "../../constants";
import {useOutletContext} from "react-router-dom";
import {LayoutOutletContext} from "../PageOutlet/PageOutlet";

const MyEpic: React.FC = () => {
    const {t} = useTranslation("translations");
    const {innerWidth} = useResize();
    const profile_id = localStorage.getItem(Keys.EPIC_PROFILE_ID);
    const isMobile = innerWidth < TABLET_VERSION;
    type Selected = "LIVE" | "MOVIE" | "SERIE"
    const [selectedIndex, setSelectedIndex] = useState<IKey>(isMobile ? 0 : 1);
    const [type, setType] = useState<Selected>("MOVIE");
    // Initialize selected based on type to ensure consistency
    const [selected, setSelected] = useState(0);
    const [reset, setReset] = useState<boolean>(false);
    const dataList = useDataList().filter((item) => item.key === 1);

    const [fetchList, {data: list, isFetching: isFetchingList}] = useLazyGetListQuery()

    const {setLayoutOptions, resetLayoutOptions} = useOutletContext<LayoutOutletContext>();

    const isWithoutMenu = Boolean(isMobile && selectedIndex !== 0)

    useEffect(() => {
        // Update type based on selected tab
        if (selected !== undefined) {
            switch (selected) {
                case 0:
                    setType("MOVIE");
                    break;
                case 1:
                    setType("SERIE");
                    break;
                case 2:
                    setType("LIVE");
                    break;
                default:
                    setType("MOVIE");
                    break;
            }
        }
    }, [selected]);


    const myListTabs = getDataMyList(t);

    useEffect(() => {
        if (!profile_id) return;

        if (selectedIndex === 1) {
            fetchList(profile_id)
        }
    }, [profile_id, selectedIndex]);

    const handleListItemClick = (index: IKey) => {
        sessionStorage.setItem("redirect", "true");
        setSelectedIndex(index);
        setReset(!reset);
    };

    const renderListItems = () => (
        <List className={styles.list}>
            {dataList.map((item) => (
                <ListItemButton
                    key={item.key}
                    selected={selectedIndex === item.key}
                    onClick={() => handleListItemClick(item.key as IKey)}
                >
                    <ListItemIcon>
                        <item.icon/>
                    </ListItemIcon>
                    <ListItemText primary={item.name} className={styles.name}/>
                    {isMobile && (
                        <ListItemIcon>
                            <NextIcon/>
                        </ListItemIcon>
                    )}
                </ListItemButton>
            ))}
        </List>
    );
    let filteredContent: any[] = [];
    switch (selectedIndex) {
        case 1:
            filteredContent = list && list[type] ? list[type] : [];
            break;
        default:
            filteredContent = [];
            break;
    }

    const renderContent = () => {
        if (isFetchingList) {
            return <Loader className={styles.loader}/>;
        }

        if (!filteredContent.length && !isFetchingList) {
            return <EmptyState label={t("MyList.noContentAvailable")}/>
        }

        // Filter content by type, safely handle undefined profileList[type]

        return (
            <Stack direction="row" flexWrap="wrap" gap="1rem" mt={5}
                   justifyContent={isMobile ? "center" : "flex-start"}>
                {filteredContent.map((item: IProfileList, index: number) => (
                    <div key={index}>
                        <MovieCard data={item}/>
                    </div>
                ))}
            </Stack>
        );
    };

    const handleBackMobile = () => {
        if (isMobile) setSelectedIndex(0)
    }


    useEffect(() => {
        setLayoutOptions({
            withoutMenu: isWithoutMenu,
            handleBack: isWithoutMenu ? handleBackMobile : undefined
        });
        return () => resetLayoutOptions();
    }, [isWithoutMenu, setLayoutOptions, resetLayoutOptions]);

    return (
        // <Layout withoutMenu={Boolean(isMobile && selectedIndex !== 0)} handleBack={handleBackMobile}>
        <div className={styles.root}>
            {!isMobile && <Typography variant="h4" className={styles.title}>{t("Aside.myEpic")}</Typography>}
            <Stack direction="row" gap={6} mt={!isMobile ? 8 : 0} alignItems="flex-start">
                {(selectedIndex === 0 || !isMobile) && renderListItems()}
                {selectedIndex === 1 && (
                    <Box sx={{width: "100%"}} display="grid">
                        <CustomTabs list={myListTabs} reset={reset} withoutAll
                                    setSelected={setSelected}/>
                        {renderContent()}
                    </Box>
                )}
            </Stack>
        </div>
        // </Layout>
    );
};

export default MyEpic;
